export const open = (state) => {
    return {
        visibility: 'Visible',
        ...state,
    };
};
export const close = () => {
    return {
        visibility: 'Hidden',
    };
};
export const isOpen = (modalState) => modalState.visibility === 'Visible';
export const isClosed = (modalState) => modalState.visibility === 'Hidden';
